export { default as RichTextHeading } from './RichTextHeading';
import React, { FC } from 'react';
import classNames from 'classnames';
import {
  documentToReactComponents,
  Options,
} from '@contentful/rich-text-react-renderer';
import {
  Block,
  BLOCKS,
  Document,
  Inline,
  MARKS,
} from '@contentful/rich-text-types';
import { HeaderSize, HeaderText } from '@/components/ui/HeaderText';
import { isRichText } from '../RichText/RichText';

interface RichTextHeadingProps {
  classNames?: string;
  content: Document | Block | Inline;
  classes?: string;
}

const renderDocument = (content: any, classes?: string) => {
  if (!isRichText(content)) return null;

  const options: Options = {
    renderMark: {
      [MARKS.ITALIC]: (text) => (
        <span className="font-bradford font-medium">{text}</span>
      ),
    },
    renderNode: {
      [BLOCKS.HEADING_1]: (node, children) => (
        <HeaderText
          classes={classNames('mb-4 md:mb-6', classes)}
          size={HeaderSize.H1}
          text={children}
        />
      ),
      [BLOCKS.HEADING_2]: (node, children) => (
        <HeaderText
          classes={classNames('mb-4 md:mb-6', classes)}
          size={HeaderSize.H2}
          text={children}
        />
      ),
      [BLOCKS.HEADING_3]: (node, children) => (
        <HeaderText
          classes={classNames('mb-4 md:mb-6', classes)}
          size={HeaderSize.H3}
          text={children}
        />
      ),
      [BLOCKS.HEADING_4]: (node, children) => (
        <HeaderText
          classes={classNames('mb-4 md:mb-6', classes)}
          size={HeaderSize.H4}
          text={children}
        />
      ),
    },
    // Allows for shift + enter breaks
    renderText: (text) => {
      return text
        .split('\n')
        .reduce<React.ReactNode[]>((children, textSegment, index) => {
          const elementsToAdd: React.ReactNode[] = [];
          if (index > 0) {
            elementsToAdd.push(<br key={index} />);
          }
          elementsToAdd.push(textSegment);
          return [...children, ...elementsToAdd];
        }, []);
    },
  };

  const renderRichText = documentToReactComponents(content, options);
  return renderRichText ? renderRichText : null;
};

const RichTextHeading: FC<RichTextHeadingProps> = ({
  content,
  classNames,
  classes,
}) => <div className={classNames}>{renderDocument(content, classes)}</div>;

export default React.memo(RichTextHeading);
